// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LetterRecipientPicker from './data'

export default function LetterRecipientPickerFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LetterRecipientPicker">
      <LetterRecipientPicker {...props}>
        {children}
      </LetterRecipientPicker>
    </Flow>
  )
}
